import {injectable} from "inversify";
import {LineupEnum} from "@/modules/base/enums";
import chance from "@/modules/base/services/chance";
import {Match} from "@/modules/match/entity";
import {Season} from "@/modules/season/entity";
import {FriendlyCompetition, Matchday} from "@/modules/competitions/entity";
import {Country} from "@/modules/base/entity";
import {Player, Team} from "@/modules/team/entity";
import {app} from "@/di";
import TeamFactory from "@/modules/team/services/factories/TeamFactory";
import {AIQualityLevelEnum} from "@/modules/ai/enums";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {FormationEnum} from "@/modules/team/enums";
import AIServiceProvider from "@/modules/ai/services/AIServiceProvider";
import FastPlayerFactory from "@/modules/team/services/factories/FastPlayerFactory";

@injectable()
export default class FriendlyGenerator {
  public async generate(data: { home: boolean, skillRange: [number, number] }): Promise<Match> {
    const season = await Season.current();

    const competition = await FriendlyCompetition
      .createQueryBuilder('competition')
      .innerJoinAndSelect('competition.divisions', 'division')
      .getOneOrFail();

    const matchday = new Matchday();
    matchday.season = season;
    matchday.scheduledAt = season.currentDate.add(1, 'day').toDate();
    matchday.name = `friendly match`;
    matchday.division = competition.divisions[0];
    await matchday.save();

    const country = await Country
      .createQueryBuilder('country')
      .innerJoinAndSelect('country.region', 'region')
      .orderBy('RANDOM()')
      .getOneOrFail();

    const currentTeam = await Team.current();

    const oppTeam = await app.get(TeamFactory).generate(country, 1, t => {
      t.aiQualityLevel = AIQualityLevelEnum.BEST;
    });
    await oppTeam.load('players');

    const definition = app.get(ConfigRepository).get('formations.all')[oppTeam.formation];

    await oppTeam.players.forEachAsync(async (p: Player, index: number) => {
      p.skill = chance.integer({min: Math.min(...data.skillRange), max: Math.max(...data.skillRange)});
      p.energy = 100;

      const lineup: LineupEnum = (index % 11) + 1 as LineupEnum;
      p.position = definition[lineup].position;

      await p.save();
    });
    oppTeam.formation = FormationEnum.F_433;

    await app.get(AIServiceProvider).getLineupper(oppTeam.aiQualityLevel).lineup(oppTeam);

    const match = new Match();
    match.homeTeam = data.home ? currentTeam : oppTeam;
    match.awayTeam = !data.home ? currentTeam : oppTeam;
    match.matchday = matchday;
    await match.save();

    return match;
  }
}
